<div class="main-dialog">

	<div class="dialog-header">
		<div class="header-title">
			<span style="font-size: 120%;">
				<span style="margin-right: 0.25em;">{{projectName}}</span>
				<span style="margin-right: 0.25em;" *ngIf="customer">-
					{{customer.qbId ? customer.qbDisplayName : customer.name}}</span>
			</span>
		</div>

		<div class="qb-sync-block" [ngClass]="{'has-sync': qbConnected}"
			pTooltip="{{qbConnected ? 'QB Sync' : 'No sync with QB'}}" tooltipPosition="bottom">
			QB
		</div>

		<div class="buttons-block">
			<button class="header-button" mat-button (click)="openQB()" *ngIf="qbConnected">Open QB</button>
			<button class="header-button" mat-button (click)="connectToQb()" *ngIf="!qbConnected">Connect QB</button>
		</div>

		<div style="flex: 1">

		</div>

		<button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
			<mat-icon>clear</mat-icon>
		</button>
	</div>

	<div class="tool-bar">
		<ng-container *ngIf="qbConnected">
			<button mat-button class="create-invoice-button" (click)="createEstimate()"
				[disabled]="estloadingSpinner || contentLoading"
				[ngClass]="{'disabled-button': estloadingSpinner || contentLoading}">
				<mat-icon *ngIf="!estloadingSpinner">add</mat-icon>
				<lib-mini-progress-spinner *ngIf="estloadingSpinner"></lib-mini-progress-spinner>
				<div class="button-title">New Estimate</div>
			</button>

			<button mat-button class="create-invoice-button" (click)="createInvoice()"
				[disabled]="loadingSpinner || contentLoading"
				[ngClass]="{'disabled-button': loadingSpinner || contentLoading}">
				<mat-icon *ngIf="!loadingSpinner">add</mat-icon>
				<lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
				<div class="button-title">New Invoice</div>
			</button>
		</ng-container>
	</div>

	<div class="adds-info-block" *ngIf="qbConnected">
		<div class="name-blocck">
			<div class="name-title">
				{{customer.qbDisplayName}}
			</div>
			<div class="address-title">
				{{customer.billingInfoContact?.address}}
			</div>
		</div>
		<div class="total-overdue-block">
			<div class="pmnt total-pmnt">
				<span class="pmnt-span">
					${{totalOpenedBalance | number:'1.2-2'}}
				</span>
				<span class="pmnt-title">
					Open
				</span>
			</div>
			<div class="pmnt overdue-pmnt">
				<span class="pmnt-span">
					${{overdueOpenedBalance | number:'1.2-2'}}
				</span>
				<span class="pmnt-title">
					Overdue
				</span>
			</div>
		</div>
	</div>

	<div class="middle-content">
		<div class="order header-order">
			<div class="checkmark-blockkk">

			</div>
			<div class="date-block label-block">
				<div class="label-name" (click)="sortByLabel('createTime')" matRipple>DATE
					<i *ngIf="sortMap.get('createTime') === 1" class="pi pi-arrow-down"></i>
					<i *ngIf="sortMap.get('createTime') === 2" class="pi pi-arrow-up"></i>
				</div>
			</div>
			<div class="type-block label-block">
				<div class="label-name not-clickable">TYPE</div>
			</div>
			<div class="nom-block label-block">
				<div class="label-name" (click)="sortByLabel('docNumber')" matRipple>NO.
					<i *ngIf="sortMap.get('docNumber') === 1" class="pi pi-arrow-down"></i>
					<i *ngIf="sortMap.get('docNumber') === 2" class="pi pi-arrow-up"></i>
				</div>
			</div>
			<div class="date-block  label-block">
				<div class="label-name" (click)="sortByLabel('dueDate')" matRipple>DUE DATE
					<i *ngIf="sortMap.get('dueDate') === 1" class="pi pi-arrow-down"></i>
					<i *ngIf="sortMap.get('dueDate') === 2" class="pi pi-arrow-up"></i>
				</div>
			</div>
			<div class="balance-block label-block">
				<div class="label-name" (click)="sortByLabel('balance')" matRipple>BALANCE
					<i *ngIf="sortMap.get('balance') === 1" class="pi pi-arrow-down"></i>
					<i *ngIf="sortMap.get('balance') === 2" class="pi pi-arrow-up"></i>
				</div>
			</div>
			<div class="total-block label-block">
				<div class="label-name" (click)="sortByLabel('totalAmt')" matRipple>TOTAL
					<i *ngIf="sortMap.get('totalAmt') === 1" class="pi pi-arrow-down"></i>
					<i *ngIf="sortMap.get('totalAmt') === 2" class="pi pi-arrow-up"></i>
				</div>
			</div>
			<div class="job-block label-block">
				<div class="label-name" (click)="sortByLabel('jobName')" matRipple>Job Name
					<i *ngIf="sortMap.get('jobName') === 1" class="pi pi-arrow-down"></i>
					<i *ngIf="sortMap.get('jobName') === 2" class="pi pi-arrow-up"></i>
				</div>
			</div>
			<div class="status-block label-block">
				<div class="label-name" (click)="sortByLabel('txnStatus')" matRipple>STATUS
					<i *ngIf="sortMap.get('txnStatus') === 1" class="pi pi-arrow-down"></i>
					<i *ngIf="sortMap.get('txnStatus') === 2" class="pi pi-arrow-up"></i>
				</div>
			</div>
		</div>


		<div class="orders-block">
			<div class="order">
				<p-accordion [multiple]="true" [activeIndex]="activeIndex" (onOpen)="loadFiles($event)"
					(activeIndexChange)="onTabChanged($event)">
					<p-accordionTab class="order-tab" *ngFor="let sale of listToShow; index as i;"
						[disabled]="sale.type === 'Payment'"
						[ngClass]="{'activeAccordition': activeIndex.includes(i), 'paid-sale': sale.txnStatus === 'Paid', 'payment-sale': sale.type === 'Payment'}">
						<p-header>
							<div class="date-block label-block">
								<div class="label-name">{{sale.metaData.createTime | date: 'M/d/yy'}}</div>
							</div>
							<div class="type-block label-block">
								<div class="label-name">{{sale.type}}</div>
							</div>
							<div class="nom-block label-block">
								<div class="label-name" *ngIf="sale.type !== 'Payment'"><span>{{sale.docNumber}}</span>
								</div>
								<div class="label-name" *ngIf="sale.type === 'Payment'"><span>{{sale.id}}</span></div>
							</div>
							<div class="date-block label-block">
								<div class="label-name">{{sale.dueDate | date: 'M/d/yy'}}</div>
							</div>
							<div class="balance-block label-block">
								<div class="label-name">{{((sale.balance ? sale.balance : 0) | currency)}}</div>
							</div>
							<div class="total-block label-block">
								<div class="label-name">{{sale.totalAmt | currency}}</div>
							</div>
							<div class="job-block label-block">
								<div class="label-name" *ngIf="sale.customField[0]?.name === 'Job Name'">
									{{sale.customField[0]?.stringValue}}</div>
								<div class="label-name" *ngIf="sale.customField[1]?.name === 'Job Name'">
									{{sale.customField[1]?.stringValue}}</div>
								<div class="label-name" *ngIf="sale.customField[2]?.name === 'Job Name'">
									{{sale.customField[2]?.stringValue}}</div>
							</div>
							<div class="action-block label-block">
								<div class="label-name">{{sale.txnStatus}}</div>
							</div>
						</p-header>

						<div class="info-body-block">
							<app-est-inv-info [sale]="sale" [qbCustomers]="qbCustomers" [qbServClasses]="qbServClasses"
								[projectId]="project.id" [baseQbServClasses]="baseQbServClasses"
								(updateInvoice)="updateInvoice($event)" (deleteInvEst)="deleteInvEst($event)"
								[loadingEvents]="fileLoading$.asObservable()" (pdfUrl)="downloadPdf($event)"
								[isMobile]="isMobile">
							</app-est-inv-info>
						</div>
					</p-accordionTab>
				</p-accordion>

			</div>
		</div>

		<div class="spinner-box" *ngIf="contentLoading">
			<mat-spinner class="spinner"></mat-spinner>
		</div>

	</div>

</div>

<div class="additional-dialog" *ngIf="showPdfFile">
	<div class="dialog-header">
		<div class="header-title">
			<span style="font-size: 120%;">{{pdfHeader}}
			</span>
		</div>

		<div style="flex: 1">

		</div>

		<button mat-button class="close-button-container" disableRipple="true" (click)="hideFile()">
			<mat-icon>clear</mat-icon>
		</button>
	</div>

	<div class="pdf-block pdfboba">
		<div class="loading-block" *ngIf="pdfLoading">
			<lib-progress-spinner></lib-progress-spinner>
		</div>

		<ngx-extended-pdf-viewer [src]="blobUrl" [enablePinchOnMobile]="true" [zoom]="'page-width'"
			[showHandToolButton]="true" [showBookmarkButton]="false" [minZoom]="0.8" [showOpenFileButton]="false">
		</ngx-extended-pdf-viewer>

	</div>

</div>